import ObjectType from './ObjectType';
const FunctionType = Object.seal({
    fullName: 'Function',
    name: 'Function',
    namespace: '',
    baseType: ObjectType,
    isArray: false,
    factory: Function,
});
export default FunctionType;
